import request from '@/utils/request'

const deviceapi = {
  deviceStatus: '/cloud/gps/monitor', // 设备状态
  // deviceStatus2: '/cloud/gps/monitor', // 设备状态，带有时间校验的
  getTracks: '/cloud/track/getTracks', // 轨迹回放
  getDevices: '/cloud/gps/getDeviceByCarVin' // 根据carVin获取设备列表
}

/**
 * 提交支付
 * @param {*} parameter
 */
export function getDeviceInfo(parameter) {
  return request.get(deviceapi.deviceStatus, parameter)
}

export function getDeviceInfoForTime(parameter) {
  return request.get(deviceapi.deviceStatus2, parameter)
}

// 查询征信报告
export function zxViewReport(param) {
  return request.post('/credit/investigation/viewReport', param)
}
// 轨迹数据
export function getTracks(parameter) {
  return request.get(deviceapi.getTracks, parameter)
}
export function getDevicesByCarVin(parameter) {
  return request.get(deviceapi.getDevices, parameter)
}
// /**
//  * 获取保单
//  * @param {*} parameter
//  */
//  export function getProductList (parameter) {
//   return request.get(payapi.productList,parameter)
// }
